import { createAsyncThunk } from '@reduxjs/toolkit'
// eslint-disable-next-line import/no-cycle
import { hideNotification } from '../redux/reducers/Notifications/notifications.reducer'
import { ModesType } from '../types/Modes.type'
import { getMyAdFactoryClass } from '../utils/myAdfactoryApi/getMyAdFactory.utils'
import {
  DisplayReq,
  PerformanceDisplayResp,
} from '../utils/myAdfactoryApi/swaggerApi'

// Get options for targetings selection
export const getSelectableValuesAsync = createAsyncThunk(
  'performance/GetSelectableValues',
  async (currentMarket: string, getState) => {
    const response =
      await getMyAdFactoryClass(getState).getSelectableValues(currentMarket)
    return response
  }
)

// Process count
export const processCountForPerformanceAsync = createAsyncThunk(
  'performance/ProcessCount',
  async (
    {
      market,
      targetings,
      postalCodes,
      projectTypes,
      startDate,
      endDate,
      periodicity,
      radius,
    }: DisplayReq,
    getState
  ) => {
    const body: DisplayReq = {
      market,
      targetings,
      postalCodes,
      projectTypes,
      startDate,
      endDate,
      periodicity,
      radius,
    }
    const response = await getMyAdFactoryClass(getState).processCount2(body)
    return response
  }
)

export const recordCountForPerformanceAsync = createAsyncThunk(
  'performance/RecordCount',
  async (
    {
      cpm,
      countName,
      displayReq,
      forecasts,
      forecastSplitByPosition,
      locality,
      localityNameByZipCode,
      mafProduct,
      mafId,
      mode,
      saveBy,
      totalBudget,
      totalImpPurchased,
    }: PerformanceDisplayResp & { mode: ModesType; mafId: number },
    getState
  ) => {
    const body: PerformanceDisplayResp = {
      cpm,
      countName,
      displayReq,
      forecasts,
      forecastSplitByPosition,
      locality,
      localityNameByZipCode,
      mafProduct,
      saveBy,
      totalBudget,
      totalImpPurchased,
    }
    let response = null
    if (mode === ModesType.Edit) {
      response = await getMyAdFactoryClass(getState).displayPerformance(
        mafId,
        body
      )
    } else {
      response = await getMyAdFactoryClass(getState).recordCount2(body)
    }

    setTimeout(() => {
      getState.dispatch(hideNotification())
    }, 5000)
    return response
  }
)
